import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../style/css/homepage2026.css';
import H2Homepage from './H2homepage';
import Riboahp from './Riboahp';
import iconinvitedsoon from '../../style/icons/invitedsoon.svg';
import reservationsSvc from '../../services/reservations';
import manageareas from '../../services/manageareas';
import managetables from '../../services/managetables';

const nowHHMM = () => {
    const d = new Date();
    return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

// Upcoming reservations for today (from now onward) — the home "מוזמנים קרובים" widget.
const InvitedSoonContainer = () => {
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        (async () => {
            const [{ rows }, areaList, tables] = await Promise.all([
                reservationsSvc.listToday([]),
                manageareas.getAllArea(true).catch(() => []),
                managetables.getAllTables(true).catch(() => []),
            ]);
            if (!alive) return;
            const areaName = {};
            (Array.isArray(areaList) ? areaList : []).forEach((a) => { areaName[String(a.id || a.ID)] = a.name; });
            const tableName = {};
            (Array.isArray(tables) ? tables : []).forEach((t) => { tableName[String(t.id)] = t.name; });
            const now = nowHHMM();
            const upcoming = (rows || [])
                .map((r) => ({ ...r, hhmm: r.time ? String(r.time).slice(0, 5) : '' }))
                .filter((r) => r.hhmm && r.hhmm >= now)
                .sort((a, b) => a.hhmm.localeCompare(b.hhmm))
                .slice(0, 6)
                .map((r) => ({
                    time: r.hhmm,
                    name: r.name || '—',
                    size: `${r.party || 0}P`,
                    area: areaName[String(r.area)] || (r.area != null && Number(r.area) ? `אזור ${r.area}` : ''),
                    table: tableName[String(r.tableId)] || (r.tableId != null && Number(r.tableId) ? `שולחן ${r.tableId}` : '—'),
                }));
            setItems(upcoming);
            setLoading(false);
        })();
        return () => { alive = false; };
    }, []);

    return (
        <section className="hp-section">
            <H2Homepage title="מוזמנים קרובים" iconName={iconinvitedsoon} onViewAll={() => navigate('/board')} />
            {loading ? (
                <div className="hp-empty">טוען…</div>
            ) : items.length ? (
                <div className="hp-cards">{items.map((r, i) => <Riboahp key={i} {...r} />)}</div>
            ) : (
                <div className="hp-empty">אין הזמנות קרובות להיום</div>
            )}
        </section>
    );
};

export default InvitedSoonContainer;
